import React from 'react';
import Map from '../map/Map'
import MenuPage from '../../pages/MenuPage';


const BranchMap = (props) => {
    const {branch} = props;
    return (
        <MenuPage title={branch.branchName} onBackClick={()=>{props.history.goBack()}}>
        <Map branches={[branch]}/>
        </MenuPage>
    )
};

export default BranchMap;


// WEBPACK FOOTER //
// ./src/components/branchMap/BranchMap.js